module.exports = __webpack_public_path__ + "img/old_logo.07dde280.svg";